import "@@/core/assets/css/print.css";
import { Printd } from "printd";
import configProvider from "@@/core/configProvider";
import styles from "./getStyles";
import VueBarcode from "vue-barcode";
import { find } from "lodash";

export default {
  name: "printVarieties",
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      varieties: [],
      finalList: {},
      productName: "",
    };
  },

  mounted() {
    this.getVarieties(this.$route.query.ids,this.$route.query.store_id);
  },
  methods: {
     parsePrice(str) {
      const idx = str.indexOf("تومان");
      if (idx === -1) return 0;
      const numberPart = str.slice(0, idx).trim();
      const value = Number(numberPart.replace(/[^0-9]/g, ''));

      return isNaN(value) ? 0 : value;
    },
    adjustHeight(event) {  
      event.target.style.height = 'auto';
      event.target.style.height = `${event.target.scrollHeight}px`; 
  }, 
    print() {
      const d = new Printd();
      let _styles;
      if (configProvider.get("print_font")) {
        _styles =
          styles +
          "@font-face{font-family:'yekan-bakh';src:url(" +
          configProvider.get("print_font") +
          ") format('woff');font-weight:normal;font-style:normal;}";
      } else {
        _styles = styles;
      }
      d.print(document.getElementById("print"), [_styles]);
    },
    checkLabel(key) {
      if (key.includes("tarh")) {
        return "طرح:";
      } else if (key.includes("color")) {
        return "رنگ:";
      } else if (key.includes("size")) {
        return "سایز:";
      } else {
        return "model:";
      }
    },
    async getVarieties(product_ids,store_id) {
      let params = {};
      product_ids.split(",").forEach((id, index) => {
        params[`ids[${index}]`] = id;
      });
      const response = await this.$axios(`admin/products_excels`, {
        params: params,
      });
      if (store_id) {
        response.data.data.data.forEach(variety => {  
          variety[3].forEach(store => { 
            if (store.store_id == store_id) { 
              variety[3] = store.balance;
            }  
          });  
        });  
      }  
      this.varieties.push(...response.data.data.data);
      if (this.$route.query.variety) {
        let finded = this.varieties.find((v) => {
          return v[6] == this.$route.query.variety;
        });
        this.varieties = [];
        this.varieties.push(finded);
      }
      this.productName = this.varieties[0][1];
      this.$forceUpdate();
    },
  },
};
